<div [class.message-back-wrapper]='true'>
    <button type="button" (click)='onSubmit()' class="back-quest" (animationend)='content.reportUpdated(null)'>
        <span>< Zurück</span>
    </button>
</div>
